module.exports = __webpack_public_path__ + "be738cafc1a9f4b01c016501cb35cbab.pdf";